export default __webpack_public_path__ + "static/media/BTCB-BUSD.6fa170e6.svg";